import { Dialog, DialogTrigger, Modal as ModalComponent } from 'react-aria-components'

import ModalHeader from '@/components/modal/ModalHeader'

type FilterModalProps = {
  title?: string
  subtitle?: string
  trigger: React.ReactNode
  footerComponent?: React.ReactNode | null
  children: React.ReactNode
  size?: 'small' | null
}

export default function Modal({
  title,
  subtitle,
  trigger,
  footerComponent,
  children,
  size,
}: FilterModalProps): JSX.Element {
  const modalSizeClass = size === 'small' ? 'm-up:w-[480px]' : 'm-up:w-[830px]'

  return (
    <DialogTrigger>
      {trigger}

      <ModalComponent isDismissable className="m:w-full m:max-w-[95vw]">
        <Dialog>
          <div className="overflow-hidden rounded-lg">
            <div
              className={`modal-border relative max-h-[95vh] w-full max-w-[95vw] overflow-auto bg-white ${modalSizeClass}`}>
              <div className="flex flex-col overflow-hidden">
                {children ? children : null}

                {footerComponent ? footerComponent : null}
              </div>
            </div>
          </div>
        </Dialog>
      </ModalComponent>
    </DialogTrigger>
  )
}
